module.exports = __webpack_public_path__ + "static/media/plus-blue.f26fcf99.svg";